<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div class="pa-1">
    <h3>{{ $t('chooseDateRange') }}</h3>
    <div class="mt-2">
      <div style="display: grid;grid-template-columns: repeat(2,1fr);grid-gap: 8px">
        <div>
          <v-dialog
            ref="dialog"
            v-model="startDateDialog"
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <div class="text-overline">
                {{ $t('from') }}
              </div>
              <v-text-field
                v-model="startDate"
                :placeholder="$t('from')"
                hide-details
                outlined
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="startDate"
              :max="today"
              @input="startDateDialog=false"
            />
          </v-dialog>
        </div>
        <div>
          <v-dialog
            ref="dialog"
            v-model="endDateDialog"
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <div class="text-overline">
                {{ $t('to') }}
              </div>
              <v-text-field
                v-model="endDate"
                :placeholder="$t('to')"
                hide-details
                outlined
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="endDate"
              :max="today"
              @input="endDateDialog=false"
            />
          </v-dialog>
        </div>
      </div>
    </div>

    <div
      class="mt-4"
      style="display: grid;grid-template-columns: repeat(3,minmax(0,1fr));grid-gap: 8px"
    >
      <small-base-card
        v-for="d in currentTimeList"
        :key="d.label"
        :active="currentDateMatch(d.dateRange())"
        :style="currentDateMatch(d.dateRange())?{color:'white'}:{}"
        class="d-block overflow-hidden"
        style="width: 100%;"
        @click="dateRange=d.dateRange()"
      >
        <div
          class="d-flex justify-center align-center"
          style="height: 100%"
        >
          <div class="text-body-1 text-truncate">
            {{ $t(d.label) }}
          </div>
        </div>
      </small-base-card>
    </div>
  </div>
</template>

<script>

import SmallBaseCard from '@/views/widget/uiComponent/SmallBaseCard.vue'
import { predefinedDateRangeList, today } from '@/model/utils/DateRepository'

export default {
  name: 'DateRangePicker',
  components: { SmallBaseCard },
  props: {
    value: {
      type: Array
    }
  },
  data: function () {
    return {
      today,
      startDate: null,
      endDate: null,
      startDateDialog: null,
      endDateDialog: null,
      predefinedTimeList: predefinedDateRangeList
    }
  },
  computed: {
    currentTimeList () {
      const dayOfWeek = new Date().getDay()
      const dayOfMonth = new Date().getDate()
      const month = new Date().getMonth()
      let list = this.predefinedTimeList
      if (dayOfWeek === 1) {
        list = this.predefinedTimeList.filter(it => it.label !== 'thisWeek')
      }
      if (dayOfMonth === 1) {
        if (month === 0) {
          list = this.predefinedTimeList.filter(it => it.label !== 'thisYear')
        }
        list = this.predefinedTimeList.filter(it => it.label !== 'thisMonth')
      }
      return list
    },
    dateRange: {
      get () {
        return [this.startDate ?? this.endDate ?? today, this.endDate ?? this.startDate ?? today]
      },
      set (val) {
        if (val?.length === 2) {
          [this.startDate, this.endDate] = val
        }
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.dateRange = val
      }
    },
    startDate (val) {
      if (val > this.endDate) {
        this.endDate = val
      }
    },
    endDate (val) {
      if (val < this.startDate) {
        this.startDate = val
      }
    },
    dateRange (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    currentDateMatch (dateRange) {
      return [this.startDate, this.endDate].join() === dateRange.join()
    }
  }
}
</script>

<style scoped>

</style>
